interface CustomAlertProps {
    message: string;
    onClose?: () => void;
    onProceed?: () => void;  // Optional callback for proceed action
    onCancel?: () => void;   // Optional callback for cancel action
    showProceedCancel?: boolean;
    onContinue?: () => void; // Optional prop for continue button
}

const CustomAlert = ({ message, onClose, onProceed, onCancel, showProceedCancel, onContinue = false }: CustomAlertProps) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-8 rounded shadow-lg flex flex-col items-center justify-center" style={{ maxWidth: '65%' }}>
                <p className="text-center">{message}</p>
                {/* Conditional rendering of buttons */}
                {showProceedCancel ? (
                    <div className="mt-4 flex space-x-4">
                        <button
                            onClick={onProceed}
                            className="px-4 py-2 bg-green-500 text-white rounded"
                        >
                            Proceed
                        </button>
                        <button
                            onClick={onCancel}
                            className="px-4 py-2 bg-red-500 text-white rounded"
                        >
                            Cancel
                        </button>
                    </div>
                ) : (
                    <div className="flex space-x-4 mt-4">
                        {onClose && (
                            <button
                                onClick={onClose}
                                className="mt-4 px-4 py-2 bg-ptsgreen-normal text-white rounded"
                            >
                                OK
                            </button>
                        )}

                        {onContinue && (
                            <button
                                onClick={onContinue}
                                className="mt-4 px-4 py-2 bg-green-500 text-white rounded"
                            >
                                Continue Session
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomAlert;